import React, { useState } from 'react'
import ContactForm from './ContactForm';

export default function QueryForm() {
   
    return (
        <>
        <div className="query-banner">
        <img src="/images/hero_3.jpg" alt="seventh-sense-images" />
        <span className='query-image dine'>Enquire Now</span>
         </div>

            <div className="container query-main-container">
                <div className="row">
                    <div className="col-md-6">
                        <div className="querypageImage">
                    </div>

                    </div>

                   <ContactForm/>
                </div>
            </div>

        </>
    )
}
